<template>
  <div class="softwareProducts">
    <ul class="softwareProducts-fullpage-indicator">
      <li
        v-for="(item, index) in products"
        :key="item.id"
       
        @click="activeIndex = index"
      ></li>
    </ul>
    <transition :duration="duration" :name="transitionName">
      <!-- ... the buttons ... -->
      <div
        :key="activeIndex"
        class="view-wrapper"
        v-if="!loading"
        :style="`backgroundImage:url(${item.cover})`"
      >
        <div :class="item.id % 2 != 0 ? 'content' : 'content content1'">
          <h2>{{ item.title }}</h2>
          <div class="description">{{ item.description }}</div>
          <div class="subDescription">{{ item.subDescription }}</div>
          <div class="link">
            <el-link
              target="_blank"
              href="http://60.191.37.82:18193/zhuoRui.apk"
              >app点击下载</el-link
            >
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: "softwareProducts",
  data() {
    return {
      products: [],
      activeIndex: 0,
      transitionName: "softwareProducts",
      scrolling: false,
      duration: 1000,
      loading: false,
    };
  },
  watch: {
    activeIndex(newIndex, oldIndex) {
      if (this.scrolling) {
        return;
      }
      if (this.$route.params.id) {
        delete this.$route.params.id;
        return;
      }

      this.transitionName = newIndex < oldIndex ? "move-down" : "move-up";
    },
  },
  created() {
    this.products = [
      {
        id: "1",
        description: "个人用户",
        cover: require("@/assets/image/appBack1.png"),
        subDescription: `多品牌比价，寄快递更省钱。有专业人士负责售后，安心寄，丢必赔。手机一体化查询快递信息，随时掌握物流动态`,
      },
      {
        id: "2",
        description: "收发件一体化",
        cover: require("@/assets/image/appBack2.png"),
        subDescription:
          "用户只要在同一组织内,收发快递信息联通显示,不必频繁切换去查找关于个人的包裹信息",
      },
      {
        id: "3",
        description: "物流跟踪",
        cover: require("@/assets/image/appBack3.png"),
        subDescription:
          "点击包裹直接显示物流跟踪信息,助力企业提升物流环节的用户体验与服务质量",
        link: "15757183400",
      },
    ];
  },
  mounted() {
    window.addEventListener("mousewheel", this.mousewheelHandler);
  },
  destroyed() {
    window.removeEventListener("mousewheel", this.mousewheelHandler);
  },
  computed: {
    item() {
      return this.products[this.activeIndex] || {};
    },
  },
  methods: {
    mousewheelHandler(e) {
      if (this.scrolling) {
        return;
      }
      this.scrolling = true;
      if (e.wheelDelta > 0) {
        this.transitionName = "move-down";
        this.activeIndex =
          this.activeIndex === 0
            ? this.products.length - 1
            : this.activeIndex - 1;
      } else {
        this.transitionName = "move-up";
        this.activeIndex = (this.activeIndex + 1) % this.products.length;
      }
      setTimeout(() => {
        this.scrolling = false;
      }, this.duration);
    },
  },
};
</script>
<style lang="less" scoped>
.move-up-leave-active,
.move-up-enter-active,
.move-down-leave-active,
.move-down-enter-active {
  transition: all 0.7s;
  transition-timing-function: cubic-bezier(0.66, 0, 0.34, 1);
}
.move-up-leave-to,
.move-up-enter,
.move-down-leave-to,
.move-down-enter {
  opacity: 0;
}

.move-up-leave-to,
.move-down-enter {
  transform: translateY(-100%);
}
.move-down-leave-to,
.move-up-enter {
  transform: translateY(100%);
}

.softwareProducts {
  position: fixed;
  z-index: -1;
  top: 60px;
  right: 0;
  left: 0;
  bottom: 0;
  min-height: 500px;
  min-width: 700px;
  background: rgba(232, 233, 235, 0.151);
  &-fullpage-indicator {
    position: absolute;
    z-index: 333;
    left: 50px;
    top: 50%;
    transform: translateY(-50%);

    &-item {
      margin: 22px 0;
      width: 5vh;
      height: 5vh;
      min-height: 30px;
      min-width: 30px;
      cursor: pointer;
      transition: all 0.3s;
      border-radius: 50%;
      overflow: hidden;

      &:hover,
      &.active {
        transform: scale(1.3);
        box-shadow: 0 0 14px 0 @box-shadow-dark-color;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .view-wrapper {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: absolute;
    height: 100vh;
    width: 100%;
    // padding-top: 100px;
    padding-left: 100px;

    .content {
      width: 500px;
      transform: translateY(-180%);
      position: absolute;
      top: 50%;
      right: 0;
      margin-right: 100px;
      // text-align: center;
      .logo {
        width: 80px;
        height: 80px;
      }
      h2 {
        margin: 30px 0;
      }
      .description {
        text-align: right;
        font-weight: bold;
        font-size: 40px;
        color: #32418d;
      }
      .subDescription {
        margin-top: 10px;
        text-indent: 25px;
        color: #3d3b3b;
        line-height: 1.4;
      }
      .link {
        margin-top: 40px;
        span {
          color: @main-color;
        }
      }
    }

    .content1 {
      right: 1200px;
    }
  }
}
</style>
